import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRedo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#000000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M396-200q-97 0-166.5-63T160-420q0-94 69.5-157T396-640h252L544-744l56-56 200 200-200 200-56-56 104-104H396q-63 0-109.5 40T240-420q0 60 46.5 100T396-280h284v80H396Z" })
});
export default SvgRedo;
